import { graphqlDynamic } from "react-apollo-dynamic-query"
import gql from "graphql-tag"
import RoomStatusListWithControls from "."
import moment from "moment"
import { GRAPHQL_DATE_FORMAT } from "../../helpers/sharedConstants"
import { connect } from "react-redux"
import {
  getEntityTypeMapping,
  getMatchFromRouter,
} from "../../helpers/sharedHelperFunctions"

export const generateTableDataQuery = ({ entityType }) => {
  return gql`
    query RoomStatusList($entityId: ID!, $startAt: String!, $endAt: String!) {
      entity: ${entityType}(id: $entityId) {
        id
        name
        shiftAssignments: shiftAssignments(startAt: $startAt, endAt: $endAt) {
          id
          compliancePercentage
          longestGap
          startsAt
          endsAt
          primaryUser {
            lastName
            firstName
          }
          secondaryUser {
            lastName
            firstName
          }
          location {
            id
            name
          }
          beginningShiftChange {
            complianceMet
            bsrStartsAt
            duration
          }
          endingShiftChange {
            complianceMet
            bsrStartsAt
            duration
          }
        }
      }
    }
  `
}

const RoomStatusListWithControlsWithApollo = graphqlDynamic(
  generateTableDataQuery,
  {
    options: ({ entityId, startDate, endDate }) => ({
      variables: {
        entityId,
        startAt: startDate.format(GRAPHQL_DATE_FORMAT),
        endAt: endDate.format(GRAPHQL_DATE_FORMAT),
      },
    }),
    props: props => {
      const { error, loading, entity } = props.data
      if (error) {
        throw error
      }
      if (!loading) {
        if (!entity) {
          throw Error("404")
        }
        return {
          loading,
          entityName: entity.name,
          shiftAssignments: entity.shiftAssignments,
          entityId: entity.id,
        } // Only show entities with data for the selected time period.
      } else {
        return { loading, error, shiftAssignments: [] }
      }
    },
  }
)(RoomStatusListWithControls)

const mapStateToProps = ({
  router,
  dateRange: { startDate, endDate },
  bsrCompliance: { bsrCompliance },
}) => {
  const match = getMatchFromRouter(router)
  return {
    startDate: moment(startDate),
    endDate: moment(endDate),
    entityType: getEntityTypeMapping(match.params.entityType).singularField,
    entityId: match.params.entityId,
    bsrCompliance,
  }
}

const RoomStatusListWithControlsWithData = connect(mapStateToProps)(
  RoomStatusListWithControlsWithApollo
)

export default RoomStatusListWithControlsWithData
